import { useEvidencePermission } from '@utils/permission-hook';
import React, { useContext } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Evidence } from '@eas/common-web';
import { useAuthoredEvidence } from '@components/evidence/authored-evidence';
import { StaticDataContext } from '@components/evidence/static-data-provider';
import { Insurance } from '@models';
import { EvidenceApiUrl, ExportTag, Permission } from '@enums';
import { ActionBar } from './insurance-actionbar';
import { useColumns } from './insurance-columns';
import { Fields } from './insurance-fields';
import { useInsuranceHookedSources } from './insurance-hooked-sources';
import { useValidationSchema } from './insurance-schema';

export function Insurances() {
  const columns = useColumns();
  const validationSchema = useValidationSchema();
  const { homeCurrency } = useContext(StaticDataContext);

  const permissions = useEvidencePermission([
    Permission.BO_INSURANCE_COMPANY_MANAGE,
  ]);

  const evidence = useAuthoredEvidence<Insurance>({
    version: 4,
    identifier: 'INSURANCE',
    apiProps: {
      url: EvidenceApiUrl.INSURANCE,
      hookedSources: useInsuranceHookedSources,
    },
    tableProps: {
      columns,
      tableName: 'Poistenia',
      showBulkActionButton: false,
      reportTag: ExportTag.INSURANCE,
    },
    detailProps: {
      toolbarProps: {
        title: 'Poistenie',
        showBtn: permissions,
        ActionBar,
      },
      FieldsComponent: Fields,
      initNewItem: () => ({
        id: uuidv4(),
        compInsurance: false,
        cost: {
          currency: homeCurrency,
        },
      }),
      validationSchema,
    },
  });

  return <Evidence {...evidence} />;
}
